import { createApp } from 'vue'
import App from './App.vue'
import { router } from './router/index.js' // Make sure this line is present
import PrimeVue from 'primevue/config';
import 'primeicons/primeicons.css';
import '@r7e/shared/styles/variables.css';
import './styles/overrides.css';
// import { definePreset, defineConfig } from '@primeuix/themes';
import Material from '@primeuix/themes/material';
import i18n, { loadLocale } from './i18n/i18n';

// Register loadLocale function for lazy loading
window.__r7e_loadLocale = loadLocale;

// Load saved locale on startup if not English
const savedLocale = typeof window !== 'undefined' ? (localStorage.getItem('locale') || 'en') : 'en';
if (savedLocale !== 'en') {
  // Load the locale asynchronously - the app will start with English and switch once loaded
  loadLocale(savedLocale).catch(err => {
    console.error('Failed to load saved locale:', err);
  });
}

// Import environment configuration and cross-origin messaging
// import './config/environment.js';
import { crossOriginMessaging } from '@r7e/shared';

// Initialize cross-origin messaging for domain authentication
crossOriginMessaging.initialize();

// Add trusted origins for cross-origin messaging (customize as needed)
const r7e_auth_domain = process.env.VUE_APP_R7E_AUTH_DOMAIN || window.location.hostname;
const scheme = window.location.protocol;
// crossOriginMessaging.setAuthDomain(r7e_auth_domain);
// Add all available services as trusted origins for cross-origin messaging
const r7e_services = [
    'consumer',
    'publisher',
    'author',
    'portal'
];
for (const srv of r7e_services) {
    const envVarName = `VUE_APP_${srv.toUpperCase()}_CMS_URL`;
    const serviceUrl = process.env[envVarName];
    if (serviceUrl) {
        try {
            const urlObj = new URL(serviceUrl);
            const origin = urlObj.origin;
            crossOriginMessaging.addTrustedOrigin(origin);
        } catch (e) {
            // If URL parsing fails, fallback to default
            crossOriginMessaging.addTrustedOrigin(`${scheme}://${srv}.${r7e_auth_domain}`);
        }
    } else {
        crossOriginMessaging.addTrustedOrigin(`${scheme}://${srv}.${r7e_auth_domain}`);
    }
}

import {new_r7eApplication} from './services/api';


const app = createApp(App)

app.use(router) // Use the router
app.use(i18n) // Add this line to use i18n
import ToastService from 'primevue/toastservice';
app.use(ToastService);
import Toast from 'primevue/toast';
app.component('ToastNotification', Toast);

app.use(PrimeVue, {
    theme: {
        preset: Material,
        options: {
            darkModeSelector: '.theme-dark',
            cssLayer: {
                name: 'theme',
                index: 1
            }
        }
    }
});

// const r7eApp = new_r7eApplication();
app.provide('r7eApp', new_r7eApplication());
// app.config.globalProperties.$r7eApp = new_r7eApplication();
// console.log('r7eApp==', app.config.globalProperties.$r7eApp);

app.mount('#app')